import createAPIRequest from "../helpers/createAPIRequest";
import useRaceCall from "./useRaceCall";
//-----------
// edit race
//-----------
export default async function useEditRace(this_race) {
  console.log("---------------------");
  console.log("IN useEditRace....");
  return new Promise((resolve) => {
    //--------------------
    // set api call parms
    //--------------------
    let parm_slug = "";

    if (this_race.slug != "") {
      parm_slug = this_race.slug;
    }

    let request_parms = {
      endpoint: "api/v1/races/",
      slug: parm_slug,
    };
    //--------------------
    // create api request
    //--------------------
    let request = createAPIRequest(request_parms);
    //------------------------------------
    // remove image pending separate call
    //------------------------------------
    delete this_race.image;
    //---------------
    // set api parms
    //---------------
    let api_parms = {
      api_request: request,
      payload: this_race,
    };
    //-----------------------------
    // wait for race + image calls
    //-----------------------------
    Promise.all([useRaceCall(api_parms)]).then((response) => {
      let race = response[0][0];
      //--------------------------------
      // return race object (to get id)
      //--------------------------------
      resolve(race);
    });
  });
}
